// @todo: Migrate to 'TagGroup' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tag} from '@wandb/weave/components/Tag';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {MultiRunWorkspaceWithContext} from '../../components/MultiRunWorkspace/MultiRunWorkspaceWithContext';
import {Theme} from '../Benchmark/benchmarkTypes';
import {EmptyState} from './EmptyState';
import {useProjectParams} from './useProjectParams';

type WorkspaceTabBodyProps = {
  linkedBenchmarkInfo: Theme | null;
  isTableExpanded: boolean;
  onSetTableExpanded: (isExpanded: boolean) => void;
  runCount: number;
};

export const WorkspaceTabBody = ({
  linkedBenchmarkInfo,
  isTableExpanded,
  onSetTableExpanded,
  runCount,
}: WorkspaceTabBodyProps) => {
  const {entityName, projectName} = useProjectParams();

  if (!runCount) {
    return <EmptyState linkedBenchmarkInfo={linkedBenchmarkInfo} />;
  }

  return (
    <MultiRunWorkspaceWithContext
      entityName={entityName}
      isTableExpanded={isTableExpanded}
      onSetTableExpanded={onSetTableExpanded}
      projectName={projectName}
      recommendGrouping="group-and-jobtype"
      title={
        <TailwindContents>
          <div className="flex items-center gap-8">
            Runs{' '}
            <span className="font-normal">
              <Tag color="moon" label={runCount.toLocaleString()} />
            </span>
          </div>
        </TailwindContents>
      }
      viewType="project-view"
    />
  );
};
